import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from "@angular/core";
import { ResponseType } from "src/utils/enums";

@Component({
  selector: "app-survey-button-multi",
  templateUrl: "./survey-button-multi.component.html",
  styleUrls: ["./survey-button-multi.component.scss"],
  standalone: false
})
export class SurveyButtonMultiComponent implements OnChanges, OnInit, OnDestroy {
  @Input() questionDetails: any;
  @Input() surveyData: any;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  selectedAnswerIndexes: number[] = [];
  exclusiveAnswerIndex: number = -1;
  constructor() {
    console.log("Survey button multi component loaded.");
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  answerSelected(answer: any, answerIndex: number): void {
    const isButtonSelection = Number.isInteger(answerIndex) && answerIndex !== -1; // free text entries also trigger this function.
    const index = this.selectedAnswerIndexes.indexOf(answerIndex);

    if (!isButtonSelection) {
      // free text entry, preserve current behavior
      this.answerSelectedEvent.emit(this.convertToSurveyAnswer());
      return;
    }

    // Check if clicked answer is exclusive
    const isExclusive = answer.Exclusive === true;

    if (index >= 0) {
      // Answer is currently selected, deselect it
      this.selectedAnswerIndexes.splice(index, 1);
      if (isExclusive) {
        this.exclusiveAnswerIndex = -1;
      }
    } else {
      // Answer is not selected, add it
      if (isExclusive) {
        // If exclusive answer clicked, clear all others and select only this
        this.selectedAnswerIndexes = [answerIndex];
        this.exclusiveAnswerIndex = answerIndex;
      } else if (this.exclusiveAnswerIndex >= 0) {
        // If an exclusive answer is selected and user clicks a non-exclusive button,
        // deselect the exclusive and select this new one instead
        this.selectedAnswerIndexes = [answerIndex];
        this.exclusiveAnswerIndex = -1;
        return;
      } else {
        // Normal multi-select behavior
        this.selectedAnswerIndexes.push(answerIndex);
      }
    }

    this.answerSelectedEvent.emit(this.convertToSurveyAnswer());
  }

  ngOnChanges(): void {
    // question has changed. Reset active selection
    let indexes = [];
    if (this.questionDetails.hasOwnProperty("SelectedAnswer")) {
      let answers = this.questionDetails.SelectedAnswer?.Answers;

      if (answers) {
        answers.forEach(function (value) {
          indexes.push(value.Index);
        });
      }
    }
    this.selectedAnswerIndexes = indexes;

    // Also detect if an exclusive answer is already selected during initialization
    this.exclusiveAnswerIndex = -1;
    for (let idx of indexes) {
      const ans = this.questionDetails.PossibleAnswers?.[idx];
      if (ans?.Exclusive === true) {
        this.exclusiveAnswerIndex = idx;
        break;
      }
    }
  }

  convertToSurveyAnswer(): any {

    const selectedAnswerIds = [];
    let disclaimerText = "";

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.selectedAnswerIndexes.length; i++) {
      const answer = this.questionDetails.PossibleAnswers[this.selectedAnswerIndexes[i]];
      const answerId = answer.AnswerId;

      // Ensure description field is initialized.
      if (answer.FreeText && answer.Description === undefined){
        answer.Description = "";
      }

      if (answer.FreeText) {
        if (answer.DisclaimerText !== undefined) {
           disclaimerText = answer.DisclaimerText;
        }
        selectedAnswerIds.push({
          Index: this.selectedAnswerIndexes[i],
          AnswerId: answerId,
          Description: answer.Description?.trim(),
          ResponseType: ResponseType.FreeText
        });
      }
      else {
        selectedAnswerIds.push({
          Index: this.selectedAnswerIndexes[i],
          AnswerId: answerId
        });
      }
    }

    const surveyAnswer: any = {
        Answers: selectedAnswerIds,
        Action: this.questionDetails.Action,
        QuestionId: this.questionDetails.QuestionId,
        ResponseType: ResponseType.MultiSelect,
        DisclaimerText: disclaimerText
    };

    return surveyAnswer;
  }
}
